import toastr from "toastr";

(function () {
  var wpcf7Form = document.querySelector(".wpcf7");

  wpcf7Form.addEventListener(
    "wpcf7submit",
    function (event) {
      if (event.detail.contactFormId == "38") {
        if(event.detail.status == "mail_sent")
          toastr.success(event.detail.apiResponse.message)
        else
          toastr.warning(event.detail.apiResponse.message)
      }
    },
    false
  );
})();
